import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SearchService } from './search.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'cookbook';


  /**
   * 
   */
  constructor(
    public router: Router,
    public authService: AuthService,
    public searchSvc: SearchService
  ) { }

  /**
   * 
   */
  navHome() {
    console.log('navHome');
    this.searchSvc.recipeHits = [];
    this.router.navigate(['/search']);
  }

  /**
   * 
   */
  logout() {
    this.authService.logoutUser();
    this.router.navigate(['/search']);
  }

  /**
   * 
   */
  changeCookbook(e: any) {
    this.searchSvc.currentCookbook = e.target.value;
  }
}
